import {Markdown} from '@/componentLibrary/components/typography';
import {SpacingSmall} from '@/componentLibrary/tokens/variables';
import styled from 'styled-components';

export const Paragraph = styled(Markdown)`
  margin-bottom: ${SpacingSmall};
`;
